<template>

  <div class="recycle_container">
    <div class="detail_top" ref="pagesRef">
      <el-carousel :height="pagesHeight + 'px'" :autoplay="true" :interval="5000">
        <el-carousel-item v-for="(item,index) in detailImgList" :key="index">
          <img class="imgCls" :src="item.url">
        </el-carousel-item>
      </el-carousel>
    </div>

    <div class="detail_center_one">
      <div class="center_one_title">
        <div class="center_one_title_line"></div>
        <div class="center_one_title_content">智能三分类垃圾箱</div>
        <div class="center_one_title_line"></div>
      </div>

      <div class="center_one_body_current">
        <img style="width: 90%" class="oneBodyImgCls" src="../assets/images/bl3fl02_center_001.png"/>
      </div>

    </div>

    <div class="detail_center_two">

      <div class="center_two_a">
        <div class="center_two_a_left"></div>
        <div class="center_two_a_right"></div>
      </div>

      <div class="center_two_b">
        <div class="center_two_b_left"></div>
        <div class="center_two_b_center">智能三分类垃圾箱</div>
        <div class="center_two_b_right"></div>
      </div>

      <div class="center_two_c">
        <div class="center_two_c_a">
          整体设计简洁硬朗，线条、棱角鲜明。该设备内置满溢检测、称重检测等多种传感器，时刻检测箱体内部状态，保障设备正常运行。箱体内部有IC/ID读卡，10.1寸显示屏，投放照明灯等功能部件，用户通过刷卡或人体感应打开垃圾投放口，投递垃圾获取相应的积分奖励。
          <br>——可从源头上(居民端)解决垃圾分类问题，方便后续垃圾进行分类处理，提高效率；
          <br>——彻底的解决了传统垃圾桶对使用者存在的卫生感染的隐患；
          <br>——能有效杜绝各种传染性疾病通过垃圾进行传播和防止桶内垃圾气味溢出。
        </div>
      </div>

      <div class="center_two_d">外观尺寸</div>
      <div class="center_two_e">
        2330mm(长)*940mm(宽)*1850mm(高)
      </div>
      <div class="center_two_e">
        投口尺寸：435mm(长)*436mm(宽)
      </div>

      <div class="center_other_adorn_right">
        <img class="adorn_img" src="../assets/images/home_center_adorn.png">
      </div>

      <div class="center_two_d">应用场景</div>
      <div class="center_two_e">
        垃圾房，垃圾车，居民社区，公共场所，小区宽阔区域
      </div>

      <div class="center_two_d">分类</div>
      <div class="center_two_e">
        易腐(厨余)垃圾I其他垃圾I其他垃圾<span
          style="font-size: 24px;color: #FE0303;font-family: Source Han Sans CN;font-weight: 400;">—可定制</span>
      </div>

      <div class="center_two_d">功能</div>
      <div class="center_two_f">
        <img src="../assets/images/bl3fl02_center_002.png">
      </div>

    </div>

    <div class="detail_center_three">
      <div class="center_three_body_left">
        <div class="three_body_left_left_double">刷卡<br>开门</div>
        <div class="three_body_left_right">居民通过刷卡，识别成功后，投放门会自动打开。</div>
      </div>

      <div class="center_three_body_right">
        <div class="three_body_right_left_double">刷卡<br>取桶</div>
        <div class="three_body_right_right" style="text-align: right">清运人员刷卡自动开门，取桶进行垃圾装运，同时具备钥匙开锁取桶功能。</div>
      </div>

      <div class="center_three_body_left">
        <div class="three_body_left_left_double">检测<br>满溢</div>
        <div class="three_body_left_right">垃圾体积超过桶最高沿，指示居民垃圾桶已满，并锁住对应投放口，拒绝居民投放。</div>
      </div>

      <div class="center_three_body_right">
        <div class="three_body_right_left_double">满溢<br>指示</div>
        <div class="three_body_right_right" style="text-align: right">通过LED指示垃圾桶内垃圾满溢状态。</div>
      </div>

      <div class="center_three_body_left">
        <div class="three_body_left_left_double">数据<br>通讯</div>
        <div class="three_body_left_right">通过网络，与后台进行数据同步，如刷卡卡号、垃圾桶满溢状态等工作。</div>
      </div>

      <div class="center_three_body_right">
        <div class="three_body_right_left_double">垃圾<br>称重</div>
        <div class="three_body_right_right" style="text-align: right">对投放的垃圾进行称重。</div>
      </div>
    </div>

    <div class="detail_center_four">
      <img style="width: 40%;margin-top: 32px" src="../assets/images/bl3fl02_center_003.png"/>
      <div class="center_four_text">(可定制)</div>
    </div>
  </div>

</template>

<script>

export default {
  data() {
    return {
      pagesHeight: "",
      detailImgList: [
        {
          url: require("../assets/images/hc3620_top_001.png")
        }
      ]
    }
  },
  mounted() {
    this.$nextTick(() => {
      this.pagesHeight = this.$refs.pagesRef.clientHeight;
    })

  },
}
</script>

<style lang="less" scoped>

@import "../assets/css/detailCommon";

@media screen and (max-width: 1280px) {

  .center_one_body_current {
    height: 504px;

    .oneBodyImgCls {
      width: 100%;
      height: 504px;
    }

  }

}

@media screen and (min-width: 1281px) and (max-width: 1440px) {

  .center_one_body_current {
    height: 580px;

    .oneBodyImgCls {
      width: 100%;
      height: 580px;
    }
  }

}

@media screen and (min-width: 1441px) and (max-width: 1920px) {

  .center_one_body_current {
    height: 756px;

    .oneBodyImgCls {
      width: 100%;
      height: 756px;
    }
  }
}

.center_one_body_current {
  display: flex;

  .oneBodyImgCls {
  }
}

</style>